import { IconButton } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { IInstantNotifier } from "../../Notifier/types";


interface CopyToClipboardButtonProps {
    getData: () => ClipboardItems | string;
    notifier?: IInstantNotifier;
    title?: string;
}

const CopyToClipboardButton = (props: CopyToClipboardButtonProps) => {

    const title = props.title ?? 'Copy to clipboard';

    const handleClick = () => {

        const clipData = props.getData();

        const promise = 
          (typeof clipData == 'string') 
          ? navigator.clipboard.writeText(clipData as string) 
          : navigator.clipboard.write(clipData as ClipboardItems);

          promise
            .then(() => props.notifier?.success('Copied to clipboard'))
            .catch(error => props.notifier?.error('Failed to copy to clipboard', error));

    };

    return (
      <IconButton onClick={handleClick} color="primary" title={title}>
        <ContentCopyIcon />
      </IconButton>
    );

};

export default CopyToClipboardButton;